/* framivo-passepartout-hulmaal.js - the passepartout window (hulmål) on the
   product page. Markup: snippets/framivo-passepartout-hulmaal.liquid.

   Shown only while a passepartout colour is chosen. The customer types the
   visible part of the picture; the passepartout's outer size is the frame's
   own measurement. The picture is centred, and the border must be at least
   data-min-border cm on every side, so the window can be at most the frame
   size minus twice that.

   Hooks into assets/maaho-product.js only through window.MaahoProductGroups:
   onChange for the passepartout choice, addReadinessCheck so Add to cart waits
   for a valid window, refresh to repaint the button state. The price is not
   touched. */

(function () {
  'use strict';
  /* Framivo i18n: tekster pr. sprog (html lang). Dansk er standard. */
  var FT_LANG = (document.documentElement.lang || 'da').slice(0, 2).toLowerCase();
  var FT = {
    "da": {
      "k16": " cm foroven og forneden.",
      "k15": " cm i siderne og ",
      "k14": "Billedet centreres. Passepartoutet bliver ",
      "k13": "Indtast rammens mål nedenfor, så tjekker vi, at hulmålet passer.",
      "k10": " cm (centreret)",
      "k9": " cm.",
      "k8": " cm kan hulmålet højst være ",
      "k7": " cm passepartout hele vejen rundt. Ved en ramme på ",
      "k6": "Der skal være mindst ",
      "k5": " cm.",
      "k4": "Hulmålet kan højst være ",
      "k3": "Angiv hul bredde og hul højde i cm, fx 20,5.",
      "k2": " cm – stående eller liggende. Vælg mindre rammemål eller \"Ønsker IKKE passepartout\".",
      "k1": "Passepartout kan kun laves til rammer op til "
    },
    "sv": {
      "k16": " cm upptill och nedtill.",
      "k15": " cm på sidorna och ",
      "k14": "Bilden centreras. Passepartouten blir ",
      "k13": "Ange ramens mått nedan, så kontrollerar vi att urtaget passar.",
      "k10": " cm (centrerat)",
      "k9": " cm.",
      "k8": " cm kan urtaget som mest vara ",
      "k7": " cm passepartout runt om hela bilden. Med en ram på ",
      "k6": "Det måste vara minst ",
      "k5": " cm.",
      "k4": "Urtaget kan som mest vara ",
      "k3": "Ange urtagets bredd och höjd i cm, t.ex. 20,5.",
      "k2": " cm – stående eller liggande. Välj mindre rammått eller välj bort passepartout.",
      "k1": "Passepartout kan bara göras till ramar upp till "
    },
    "nb": {
      "k16": " cm øverst og nederst.",
      "k15": " cm på sidene og ",
      "k14": "Bildet sentreres. Passepartouten blir ",
      "k13": "Skriv inn rammens mål nedenfor, så sjekker vi at utsparingen passer.",
      "k10": " cm (sentrert)",
      "k9": " cm.",
      "k8": " cm kan utsparingen maksimalt være ",
      "k7": " cm passepartout hele veien rundt. Med en ramme på ",
      "k6": "Det må være minst ",
      "k5": " cm.",
      "k4": "Utsparingen kan maksimalt være ",
      "k3": "Oppgi utsparingens bredde og høyde i cm, f.eks. 20,5.",
      "k2": " cm – stående eller liggende. Velg mindre rammemål eller velg bort passepartout.",
      "k1": "Passepartout kan bare lages til rammer opp til "
    }
  };
  function fT(k) { var d = FT[FT_LANG] || FT.da; return d[k] != null ? d[k] : FT.da[k]; }


  function init() {
    var box = document.getElementById('mat-opening');
    var groups = window.MaahoProductGroups;
    if (!box || !groups) return;

    var groupId = box.getAttribute('data-mat-group');
    var noneId = box.getAttribute('data-mat-none') || '';
    var minBorder = parseFloat(box.getAttribute('data-min-border')) || 2;

    var widthInput = document.getElementById('mat-opening-width');
    var heightInput = document.getElementById('mat-opening-height');
    var property = document.getElementById('mat-opening-property');
    var raw = document.getElementById('mat-opening-raw');
    var message = document.getElementById('mat-opening-message');
    var frameWidth = document.getElementById('measurement-width');
    var frameHeight = document.getElementById('measurement-length');
    var form = box.closest('form');
    var touched = false;

    /* 20 / 20,5 / 20.5 - whole or one decimal, comma or point. */
    function parse(value) {
      var text = String(value || '').trim().replace(',', '.');
      if (!/^\d{1,3}(\.\d)?$/.test(text)) return NaN;
      return parseFloat(text);
    }

    function format(number) {
      return (Math.round(number * 10) / 10).toFixed(1).replace('.', ',');
    }

    function isActive() {
      var group = groups.byGroupId[groupId];
      if (!group) return false;
      var row = document.querySelector('[data-option-row="' + groupId + '"]');
      if (row && row.hidden) return false;
      var chosen = group.chosenId();
      return Boolean(chosen) && chosen !== noneId;
    }

    function frameSize() {
      var width = frameWidth ? parseFloat(frameWidth.value) : NaN;
      var height = frameHeight && !frameHeight.disabled ? parseFloat(frameHeight.value) : width;
      return { width: width, height: height };
    }

    /* The size table behind the chosen colour, when its surcharge is ['#', name]. */
    function tableFor(attributeId) {
      var pricing = window.maahoPricing;
      var surcharges = pricing && pricing.optionPrices && pricing.optionPrices.surcharges;
      var entry = surcharges ? surcharges[attributeId] : null;
      if (!entry || entry[0] !== '#' || !window.MaahoPrice) return null;
      var tables = window.MaahoPrice.sharedTables(pricing.optionPrices);
      try {
        return window.FramivoPriceTables.decodePriceTable(tables ? tables[entry[1]] || null : null);
      } catch (tableError) {
        return null;
      }
    }

    function snapUp(value, steps) {
      for (var index = 0; index < steps.length; index++) {
        if (value <= steps[index]) return steps[index];
      }
      return null;
    }

    /* Whether the table holds a price for this size, snapped up as the price is. */
    function tableCovers(table, width, height) {
      var column = snapUp(width, table.width.values);
      var row = snapUp(height, table.second.values);
      if (column === null || row === null) return false;
      var cells = table.prices[table.second.values.indexOf(row)];
      var cell = cells ? cells[table.width.values.indexOf(column)] : null;
      return typeof cell === 'number' && cell > 0;
    }

    /* '70 × 100': the longest side the table goes to, and the longest short
       side that still has a price at that length. */
    function tableLimit(table) {
      var longest = table.width.max;
      var shortest = table.second.values.filter(function (value) {
        return tableCovers(table, longest, value);
      }).pop() || table.second.min;
      return format(Math.min(shortest, longest)).replace(',0', '') + ' × ' + format(longest).replace(',0', '');
    }

    /* ok: Add to cart may go ahead as far as the window is concerned. */
    function check() {
      if (!isActive()) return { ok: true };

      /* A table priced by the frame (no 'measure') covers the frame sizes a
         passepartout can be made for; outside it there is no passepartout. */
      var frameTable = tableFor(groups.byGroupId[groupId].chosenId());
      if (frameTable && !frameTable.measure) {
        var frameNow = frameSize();
        if (!isNaN(frameNow.width) && !isNaN(frameNow.height)
            && !tableCovers(frameTable, frameNow.width, frameNow.height)) {
          return {
            ok: false,
            badWidth: false,
            badHeight: false,
            text: fT('k1') + tableLimit(frameTable)
              + fT('k2')
          };
        }
      }

      var width = parse(widthInput.value);
      var height = parse(heightInput.value);
      var empty = widthInput.value.trim() === '' && heightInput.value.trim() === '';

      if (isNaN(width) || isNaN(height) || width < 1 || height < 1) {
        return {
          ok: false,
          empty: empty,
          badWidth: isNaN(width) || width < 1,
          badHeight: isNaN(height) || height < 1,
          text: fT('k3')
        };
      }

      /* Priced from the size table by the window itself, so the window has to
         be a size the table covers. */
      var table = tableFor(groups.byGroupId[groupId].chosenId());
      if (table && table.measure && (width > table.width.max || height > table.second.max)) {
        return {
          ok: false,
          badWidth: width > table.width.max,
          badHeight: height > table.second.max,
          text: fT('k4') + table.width.max + ' × ' + table.second.max + fT('k5')
        };
      }

      var frame = frameSize();
      if (isNaN(frame.width) || isNaN(frame.height)) {
        return { ok: true, pending: true, width: width, height: height };
      }

      var maxWidth = frame.width - 2 * minBorder;
      var maxHeight = frame.height - 2 * minBorder;
      if (width > maxWidth || height > maxHeight) {
        return {
          ok: false,
          badWidth: width > maxWidth,
          badHeight: height > maxHeight,
          text: fT('k6') + format(minBorder).replace(',0', '')
            + fT('k7')
            + format(frame.width).replace(',0', '') + ' × ' + format(frame.height).replace(',0', '') + fT('k8')
            + format(Math.max(maxWidth, 0)) + ' × ' + format(Math.max(maxHeight, 0)) + fT('k9')
        };
      }

      return {
        ok: true,
        width: width,
        height: height,
        sideBorder: (frame.width - width) / 2,
        topBorder: (frame.height - height) / 2
      };
    }

    function render() {
      var active = isActive();
      box.hidden = !active;
      widthInput.disabled = !active;
      heightInput.disabled = !active;
      property.disabled = !active;
      raw.disabled = !active;

      var state = check();

      if (active && state.ok && typeof state.width === 'number') {
        property.value = format(state.width) + ' × ' + format(state.height) + fT('k10');
        raw.value = 'Bredde:' + state.width + ';Højde:' + state.height;
      } else {
        property.value = '';
        raw.value = '';
      }

      var showError = active && !state.ok && (touched || !state.empty);
      widthInput.classList.toggle('invalid', Boolean(showError && state.badWidth));
      heightInput.classList.toggle('invalid', Boolean(showError && state.badHeight));
      widthInput.setAttribute('aria-invalid', showError && state.badWidth ? 'true' : 'false');
      heightInput.setAttribute('aria-invalid', showError && state.badHeight ? 'true' : 'false');

      var text = '';
      if (showError) {
        text = state.text;
      } else if (active && state.pending) {
        text = fT('k13');
      } else if (active && state.ok && typeof state.sideBorder === 'number') {
        text = fT('k14') + format(state.sideBorder)
          + fT('k15') + format(state.topBorder) + fT('k16');
      }
      message.textContent = text;
      message.hidden = text === '';
      message.classList.toggle('is-error', Boolean(showError));

      groups.refresh();
    }

    /* The window, for a ['#', 'mat'] surcharge priced by it - see maaho-price.js.
       Only a complete, valid window: anything less prices as nothing and Add to
       cart waits on the readiness check below. */
    window.maahoExtraMeasures = function () {
      if (!isActive()) return null;
      var state = check();
      if (!state.ok || typeof state.width !== 'number') return null;
      return { _mat_opening: { width: state.width, second: state.height } };
    };

    groups.addReadinessCheck(function () { return check().ok; });
    groups.onChange(render);

    [widthInput, heightInput].forEach(function (input) {
      /* Spinner and typing both land here; cut anything past one decimal, as the frame fields do. */
      input.addEventListener('input', function () {
        var parts = input.value.split('.');
        if (parts.length === 2 && parts[1].length > 1) input.value = parts[0] + '.' + parts[1].slice(0, 1);
      });
      input.addEventListener('input', render);
      input.addEventListener('blur', function () { touched = true; render(); });
    });
    [frameWidth, frameHeight].forEach(function (input) {
      if (input) input.addEventListener('input', render);
    });

    /* maaho-product.js already blocks the submit when a check fails; this only
       points the customer at the window, which it does not know about. */
    if (form) {
      form.addEventListener('submit', function (event) {
        if (check().ok) return;
        event.preventDefault();
        touched = true;
        render();
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        box.classList.add('needs-attention');
        setTimeout(function () { box.classList.remove('needs-attention'); }, 2500);
      });
    }

    render();
  }

  /* After maaho-product.js has registered its groups, whichever way it does it. */
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  }
})();
